export const BRAND = "InfantSleepConsultantNearMe.com";

export const METHOD = {
  name: "The Infant Sleep Clarity Method",
  steps: [
    { key: "understand", label: "Understand", desc: "Understand the sleep pattern." },
    { key: "prioritize", label: "Prioritize", desc: "Identify what matters most." },
    { key: "plan", label: "Plan", desc: "Create a personalized strategy." },
    { key: "implement", label: "Implement", desc: "Put the strategy into practice." },
    { key: "adjust", label: "Adjust", desc: "Review what happened and adapt." },
    { key: "support", label: "Support", desc: "Add professional support at the level needed." },
  ],
};

// Marketing money pages keyed by product
export const MONEY_PAGES = {
  diagnostic: "/infant-sleep-diagnostic",
  blueprint: "/personalized-infant-sleep-blueprint",
  guided: "/guided-infant-sleep-consulting",
  inhome_overnight: "/in-home-infant-sleep-consulting",
};

export const PROBLEMS = [
  { key: "constant_waking", label: "My baby wakes constantly", cluster: "night_wakings" },
  { key: "short_naps", label: "Naps last 20-30 minutes", cluster: "naps" },
  { key: "crib", label: "My baby won't sleep in the crib", cluster: "crib" },
  { key: "bedtime", label: "Bedtime takes forever", cluster: "bedtime" },
  { key: "regression", label: "Everything suddenly changed", cluster: "regressions" },
  { key: "unsure", label: "I don't know what's wrong", cluster: "" },
];

export const CLUSTER_LABELS = {
  commercial: "Understanding Professional Support", night_wakings: "Night Wakings", naps: "Naps", crib: "Crib Sleep",
  bedtime: "Bedtime", regressions: "Regressions", age: "Sleep by Age", schedules: "Schedules",
  buying_intent: "Understanding Professional Support",
  newborn: "Newborn Sleep", safe_sleep: "Safe Sleep & Sleep Environment", sleep_problems: "Baby Sleep Problems & Solutions",
  toddler: "Toddler Sleep", family_courses: "Family Sleep & Course Education",
};

export function money(n) {
  return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });
}
